module.exports = __webpack_public_path__ + "img/logo.b91f9296.png";